import { FilterX } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

interface Props {
    /** True khi đang có ít nhất 1 filter khác default → nút active. */
    active: boolean
    onClear: () => void
    size?: 'sm' | 'default'
    variant?: 'outline' | 'ghost'
    className?: string
}

/** Nút "Xoá lọc" dùng cho mọi page list có filter. Convention dự án: khi
 *  page có filter (lưu URL search params), bắt buộc có nút này để user reset
 *  về default. */
export function ClearFilterButton({
    active,
    onClear,
    size = 'sm',
    variant = 'outline',
    className,
}: Props) {
    return (
        <Button
            size={size}
            variant={variant}
            disabled={!active}
            onClick={onClear}
            className={className}
            title={m.common_clear_filter()}
        >
            <FilterX className="size-4 mr-1" />
            {m.common_clear_filter()}
        </Button>
    )
}
